"use client";

import Layout from "@/app/components/appcomponents/Layout";
import ObituaryCard from "@/app/components/appcomponents/ObituaryCard";
import HomeBackHeader from "@/app/components/appcomponents/HomeBackHeader";
// import Dropdown from "@/app/components/appcomponents/Dropdown";
import NotificationView from "@/app/components/appcomponents/NotificationView";
import IphoneView from "@/app/components/appcomponents/IphoneView";
// import IpadView from "@/app/components/appcomponents/IpadView";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import PopUp from "@/app/components/appcomponents/popup";
import MessagePopUp from "@/app/components/appcomponents/MessagePopup";
import Link from "next/link";
import { useState, useEffect, useRef, useMemo } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import {
  LocalQuickReview,
  //   LocalQuickReviewModal,
} from "@/app/components/appcomponents/LocalQuickReview";
import MegaMenu from "@/app/components/appcomponents/MegaMenuMain";
import obituaryService from "@/services/obituary-service";
import { matchesObituaryName } from "@/utils/obituaryNameSearch";
// import { toast } from "react-hot-toast";
import regionsAndCities from "@/utils/regionAndCities";
import { cityToSlug } from "@/utils/citySlug";
// import MainOptions from "./components/appcomponents/MainOptions";
import HomePageBox from "@/app/components/appcomponents/HomePageBox";
import IpadSlider from "@/app/components/appcomponents/IpadSlider";
// import SlideOne from "./components/slidercomponents/SlideOne";
// import SlideTwo from "./components/slidercomponents/SlideTwo";
import { useAuth } from "@/hooks/useAuth";
import { SelectDropdown } from "@/app/components/appcomponents/SelectDropdown";
import HomeTabs from "@/app/components/appcomponents/HomeTabs";
import HomeThanksTab from "@/app/components/appcomponents/HomeThanksTab";
import WhatsNewPopup from "@/app/components/appcomponents/WhatsNewPopup";
import { SelectRegionDropdown } from "@/app/components/appcomponents/SelectRegionDropdown";

export default function HomeContent(props) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [obituaries, setObituaries] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [isLocalQuickModalVisible, setIsLocalQuickModalVisible] =
    useState(false);
  // Initialize from URL so the first fetch uses correct region/city (avoids race with URL sync effect)
  const [selectedCity, setSelectedCity] = useState(
    () => searchParams.get("city") ?? null
  );
  const [selectedRegion, setSelectedRegion] = useState(
    () => searchParams.get("region") ?? null
  );
  const [name, setName] = useState(() => {
    const s = searchParams.get("search");
    if (s == null || String(s).trim() === "") return null;
    try {
      return decodeURIComponent(String(s)).replace(/\+/g, " ").trim() || null;
    } catch {
      return String(s).replace(/\+/g, " ").trim() || null;
    }
  });
  const [selectedFloristCity, setSelectedFloristCity] = useState(null);
  const [obitLoading, setObitLoading] = useState(false);
  const lastUrlReplaceByUsRef = useRef(0);

  // Tabs: "latest" = Zadnje osmrtnice, "trending" = V zadnjih dneh (most candles), "thanks" = Zahvale, spomini.
  // Coming back from the Stripe checkout of a new message lands on the "Zahvale, spomini" tab.
  const [activeTab, setActiveTab] = useState(() =>
    searchParams.get("thankYouMessage") || searchParams.get("thankYouCanceled") ?
      "thanks"
    : "trending"
  );
  // Phones show the open tab as the title and only the other two tabs in the row.
  const [isMobile, setIsMobile] = useState(false);
  const [nameFocused, setNameFocused] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 742px)");
    const sync = () => setIsMobile(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  // Normalize search term: decode % and treat + as space (for URL/form encoding)
  const normalizeSearchTerm = (term) => {
    if (term == null || String(term).trim() === "") return "";
    try {
      return decodeURIComponent(String(term)).replace(/\+/g, " ").trim();
    } catch {
      return String(term).replace(/\+/g, " ").trim();
    }
  };

  // Sync state when URL params change (e.g. back/forward). Skip syncing search/name
  // right after we updated the URL from typing, so the space key doesn't get overwritten.
  useEffect(() => {
    const cityParam = searchParams.get("city");
    const regionParam = searchParams.get("region");
    const searchParam = searchParams.get("search");
    setSelectedCity(cityParam ?? null);
    setSelectedRegion(regionParam ?? null);
    const justUpdatedByUs = Date.now() - lastUrlReplaceByUsRef.current < 400;
    if (!justUpdatedByUs) {
      const normalized = normalizeSearchTerm(searchParam);
      setName(normalized ? normalized : null);
    }
  }, [searchParams]);

  // Prepare region options
  const regionOptions = [
    { place: "- Pokaži vse regije -", id: "allRegions" },
    ...Object.keys(regionsAndCities).map((region) => ({
      place: region,
      id: region,
    })),
  ];

  // // Prepare city options (independent of region)
  // const cityOptions = [
  //   { place: "- Pokaži vse občine -", id: "allCities" },
  //   ...Object.values(regionsAndCities)
  //     .flat()
  //     .map((city) => ({
  //       place: city,
  //       id: city,
  //     }))
  //     .sort((a, b) => a.place.localeCompare(b.place, "sl")),
  // ];

  // Prepare city options (dependent on region)
  const allCitiesOption = { place: "- Pokaži vse občine -", id: "allCities" };
  const cityOptions =
    selectedRegion &&
    selectedRegion !== "allRegions" &&
    selectedRegion !== "- Pokaži vse regije -"
      ? [
          allCitiesOption,
          ...regionsAndCities[selectedRegion].map((city) => ({
            place: city,
            id: city,
          })),
        ]
      : [
          allCitiesOption,
          ...Object.values(regionsAndCities)
            .flat()
            .map((city) => ({
              place: city,
              id: city,
            }))
            .sort((a, b) => a.place.localeCompare(b.place, "sl")),
        ];

  // Handle region select
  const handleRegionSelect = (item) => {
    // if (item.id === "allRegions") {
    //   updateParams(selectedCity, null);
    //   return;
    // }
    // setSelectedRegion(item.place);
    // updateParams(selectedCity, item.place, name);

    if (item.id === "allRegions" || item.id === "- Pokaži vse regije -") {
      setSelectedRegion(null);
      setSelectedCity(null);
      updateURL(selectedCity, null, name);
    } else {
      setSelectedRegion(item.place);
      setSelectedCity(null);
      updateURL("", item.place, name);
    }
  };

  const handleNameChange = (name) => {
    setName(name);
    updateParams(selectedCity, selectedRegion, name);
  };

  const updateURL = (city, region, search) => {
    const params = new URLSearchParams(window.location.search);
    if (city && city !== "allCities" && city !== "- Pokaži vse občine -") {
      params.set("city", city);
    } else {
      params.delete("city");
    }
    if (!city) {
      setSelectedCity("");
      params.delete("city");
    }
    if (
      region &&
      region !== "allRegions" &&
      region !== "- Pokaži vse regije -"
    ) {
      params.set("region", region);
    } else {
      params.delete("region");
    }
    if (search) {
      params.set("search", search);
    } else {
      params.delete("search");
    }
    const queryString = params.toString();
    const newURL = queryString ? `?${queryString}` : window.location.pathname;
    lastUrlReplaceByUsRef.current = Date.now();
    router.replace(newURL, { scroll: false });
  };

  // Handle city select
  const handleCitySelect = (item) => {
    // if (item.id === "allCities") {
    //   setSelectedCity(null);
    //   updateParams(null, selectedRegion);
    //   return;
    // }
    // setSelectedCity(item.place);
    // updateParams(item.place, selectedRegion, name);

    if (item.id === "allCities" || item.place === "- Pokaži vse občine -") {
      setSelectedCity(null);
      updateURL(null, selectedRegion, name);
    } else {
      // Like the Funerals page: a city is its own page (/osmrtnice/celje), not a ?city= filter.
      setSelectedCity(item.place);
      goToCityPage(item.place);
    }
  };

  const goToCityPage = (city) => {
    const slug = cityToSlug(city);
    if (!slug) return;
    const search = name && String(name).trim() ? `?search=${encodeURIComponent(String(name).trim())}` : "";
    router.push(`/osmrtnice/${slug}${search}`);
  };

  // Handler for florist city dropdown
  const handleFloristCitySelect = (item) => {
    if (item.id === "allCities") {
      setSelectedFloristCity(null);
    } else {
      setSelectedFloristCity(item.place);
      // Redirect to cvetlicarne page with selected city
      router.push(`/cvetlicarne?city=${encodeURIComponent(item.place)}`);
    }
  };

  // Update URL params - improved version
  const updateParams = (city, region, name = "") => {
    const params = new URLSearchParams();

    // Keep existing florist city if it exists
    const currentFloristCity = searchParams.get("floristCity");
    if (currentFloristCity) {
      params.set("floristCity", currentFloristCity);
    }

    // Add city and region if they exist
    if (city) params.set("city", city);
    if (region) params.set("region", region);
    if (name && name.length > 0) params.set("search", name);

    const queryString = params.toString();
    lastUrlReplaceByUsRef.current = Date.now();
    router.replace(queryString ? `/?${queryString}` : "/", { scroll: false });
  };

  const prevNameRef = useRef(name);
  const searchDebounceRef = useRef(null);
  useEffect(() => {
    // "Zahvale, spomini" has no obituary list and no search.
    if (activeTab === "thanks") return;
    const nameChanged = prevNameRef.current !== name;
    prevNameRef.current = name;
    if (nameChanged) {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
      searchDebounceRef.current = setTimeout(() => {
        searchDebounceRef.current = null;
        fetchObituary();
      }, 650);
      return () => {
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
      };
    }
    fetchObituary();
  }, [selectedCity, selectedRegion, name, activeTab]);

  const fetchObituary = async () => {
    try {
      // The trending list is only the 8 most lit candles. Searching there is the general search
      // (same as the first tab), so the visitor can find anyone, not just those 8.
      const hasFilter =
        Boolean(selectedCity && selectedCity != "- Pokaži vse občine -") ||
        Boolean(selectedRegion && selectedRegion != "- Pokaži vse regije -") ||
        Boolean(name != null && String(name).trim() !== "");
      const isTrending = activeTab === "trending" && !hasFilter;
      const queryParams = isTrending ? {} : { limit: 8, page: 1 };

      if (selectedCity && selectedCity != "- Pokaži vse občine -")
        queryParams.city = selectedCity;
      if (selectedRegion && selectedRegion != "- Pokaži vse regije -")
        queryParams.region = selectedRegion;
      if (name != null && String(name).trim() !== "")
        queryParams.name = String(name).trim();

      setObitLoading(true);
      const response = isTrending
        ? await obituaryService.getTrendingObituaries(queryParams)
        : await obituaryService.getObituary(queryParams);
      setObitLoading(false);

      if (response.error) {
        return;
      }
      setObituaries(response.obituaries ?? []);
    } catch (err) {
      setObitLoading(false);
      console.error("Error fetching obituary:", err);
      // toast.error(err.message || "Failed to fetch obituary.");
    }
  };

  // Same behaviour as the Funerals page: the search button writes the filters to the URL and fetches.
  const handleSearch = () => {
    if (selectedCity && selectedCity !== "- Pokaži vse občine -") {
      goToCityPage(selectedCity);
      return;
    }
    updateURL(selectedCity, selectedRegion, name);
    fetchObituary();
  };

  // Name suggestions come from the obituaries already loaded for the current filters.
  const nameSuggestions = useMemo(() => {
    if (!normalizeSearchTerm(name)) return [];
    return obituaries.filter((obit) => matchesObituaryName(obit, name));
  }, [obituaries, name]);

  const updateObituary = (id) => {
    setObituaries((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, totalCandles: (item.totalCandles ?? 0) + 1 }
          : item
      )
    );
  };

  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [showContent, setShowContent] = useState(true);

  const funcMegaMenu = () => {
    window.scrollTo({
      top: 0,
    });
    setShowMegaMenu(!showMegaMenu);
  };

  useEffect(() => {
    if (showMegaMenu) {
      // Disable scrolling when the MegaMenu is open
      document.body.style.overflow = "hidden";
    } else {
      // Enable scrolling when the MegaMenu is closed
      document.body.style.overflow = "auto";
    }

    // Cleanup function to ensure scrolling is restored when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showMegaMenu]);
  console.log("------------DEPLOYMENT TESTING------------");
  return (
    <Layout
      isMegaMenuVisible={showMegaMenu}
      from={"1"}
      forFooter={""}
      megaMenu={funcMegaMenu}
    >
      <div className="absolute z-40 w-full mx-auto mt-[132px] tablet:mt-[122px] mobile:mt-[112px] overflow-auto">
        {showMegaMenu && <MegaMenu />}
      </div>
      <div className="flex flex-1 mx-auto w-full flex-col bg-[#F5F7F9]">
        <HomeBackHeader />
        <WhatsNewPopup />
        {isModalVisible && <PopUp setIsModalVisible={setIsModalVisible} />}
        {isMessageModalVisible && (
          <MessagePopUp setIsMessageModalVisible={setIsMessageModalVisible} />
        )}
        {isLocalQuickModalVisible && (
          <LocalQuickReview
            setIsLocalQuickModalVisible={setIsLocalQuickModalVisible}
          />
        )}

        <div className={`flex flex-col items-center desktop:w-[1280px] tablet:w-[680px] mobile:w-[100%] ${activeTab === "thanks" ? "mobile:max-w-[524px]" : "mobile:max-w-[400px]"} mx-auto mobile:px-3`}>
          <div
            className="flex items-center 
        desktop:mt-[60.73px] tablet:mt-[67.73px] mobile:mt-[22px]
        desktop:h-[47px] tablet:h-[47px] mobile:h-[33px]"
          >
            <h1 className="mobile:font-variation-customOpt28 tablet:font-variation-customOpt40 desktop:font-variation-customOpt40 desktop:text-[40px] tablet:text-[40px] mobile:text-[28px]  text-[#1E2125] leading-[46.88px] ">
              {activeTab === "thanks" ? (
                "Zahvale, spomini"
              ) : activeTab === "trending" ? (
                "V zadnjih dneh"
              ) : (
                "Zadnje osmrtnice"
              )}
            </h1>
          </div>
          <div className="mt-3 mobile:mt-[13px]">
            <HomeTabs
              activeId={activeTab}
              onChange={setActiveTab}
              hideActive={isMobile}
              tabs={[
                { id: "latest", label: "Zadnje osmrtnice" },
                { id: "trending", label: "V zadnjih dneh" },
                { id: "thanks", label: "Zahvale, spomini" },
              ]}
            />
          </div>
          {activeTab !== "thanks" && (
          <div
            className="flex flex-col desktop:flex-row 
        desktop:mt-[61px] tablet:mt-[55px] mobile:mt-[35px]
        desktop:w-[777px] tablet:w-[600px] mobile:w-[296px]
          items-center justify-center relative"
          >
            {obitLoading ? (
              <div className="absolute top-0 left-0 h-full w-full z-50"></div>
            ) : null}
            <form
              role="search"
              aria-label="Iskanje osmrtnic"
              onSubmit={(e) => {
                e.preventDefault();
                handleSearch();
              }}
              className="flex flex-col w-full items-center gap-[16px] mobile:mb-[40px] tablet:grid tablet:grid-cols-[292px_292px] tablet:justify-between desktop:flex desktop:flex-row"
            >
              <div className="relative w-[292px] desktop:w-[227px] h-[48px]">
                <input
                  type="text"
                  name="ime"
                  placeholder="Išči po imenu / priimku"
                  aria-label="Išči po imenu / priimku"
                  autoComplete="off"
                  value={name ?? ""}
                  onChange={(e) => handleNameChange(e.target.value)}
                  onFocus={() => setNameFocused(true)}
                  onBlur={() => setNameFocused(false)}
                  className="w-full h-full bg-white border border-[#7C7C7C] rounded-lg px-[15.8px] text-[16px] leading-6 font-[400] text-[#7C7C7C] placeholder-[#7C7C7C] focus:outline-none"
                  style={{ fontVariationSettings: "'opsz' 16" }}
                />
                {nameFocused && nameSuggestions.length > 0 && (
                  <div
                    className="absolute w-full top-[100%] z-[9999] bg-[#f1fffe] my-[8px] box-border rounded-[4px]"
                    style={{
                      boxShadow:
                        "0 0 0 1px hsla(0, 0%, 0%, 0.1),0 4px 11px hsla(0, 0%, 0%, 0.1)",
                    }}
                  >
                    <div className="max-h-[300px] py-[4px] relative overflow-y-auto">
                      {nameSuggestions.map((obit) => (
                        <div
                          key={obit.id ?? obit.slugKey}
                          className="text-[#7d7d7d] py-[8px] px-[12px] cursor-pointer select-none bg-transparent hover:bg-[#6D778E] hover:text-white box-border rounded-[0.375rem]"
                          // mousedown fires before the input's blur hides this list
                          onMouseDown={() => {
                            window.location.href = `/m/${obit.slugKey}`;
                          }}
                        >{`${obit.name} ${obit.sirName}${obit.city ? `, ${obit.city}` : obit.location ? `, ${obit.location}` : ""}`}</div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Region in the middle, city (občina) on the right: choosing a region narrows the cities. */}
              <div className="mobile:hidden">
                <SelectDropdown
                  heading={"Regija"}
                  label={"Regija"}
                  name="regija"
                  isFromNotification={false}
                  isFromFlower={false}
                  data={regionOptions}
                  selectedValue={selectedRegion}
                  onSelect={handleRegionSelect}
                />
              </div>
              <SelectDropdown
                heading={"Občina"}
                data={cityOptions}
                label={"Občina"}
                name="kraj"
                isFromNotification={false}
                isFromFlower={false}
                selectedValue={selectedCity}
                onSelect={handleCitySelect}
              />
              <button
                type="submit"
                aria-label="Išči"
                className="hidden desktop:flex justify-center w-12 items-center h-full desktop:aspect-square rounded-lg bg-[#414141]"
              >
                <MagnifyingGlassIcon className="w-5 h-5 text-white" />
              </button>
              <button
                type="submit"
                className="flex desktop:hidden min-h-[48px] w-[296px] tablet:w-[292px] bg-[#414141] rounded-[8px] justify-center items-center"
              >
                <div
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    color: "#F6F6F6",
                    fontVariationSettings: "'opsz' 16",
                  }}
                >
                  Prikaži
                </div>
              </button>
            </form>
          </div>
          )}

          {activeTab === "thanks" ? (
            <HomeThanksTab isMobile={isMobile} />
          ) : (
            <>
          <div className="mx-auto hidden tablet:hidden desktop:grid desktop:grid-cols-2 grid-cols-1 tablet:gap-6 desktop:gap-6 mt-[43px] tablet:mt-[64px] desktop:mt-[47.93px] justify-between">
            {obituaries.slice(0, 8).map((obituary, index) => (
              <ObituaryCard
                data={obituary}
                index={index}
                key={index}
                mob={false}
                selectedCity={selectedCity}
                selectedRegion={selectedRegion}
                onCandleBurned={updateObituary}
              />
            ))}
          </div>
          <div className="mx-auto hidden tablet:grid grid-cols-1 desktop:hidden desktop:grid-cols-2 tablet:gap-6 desktop:gap-6 mt-[43px] tablet:mt-[64px] desktop:mt-[47.93px] justify-between">
            {obituaries.slice(0, 8).map((obituary, index) => (
              <ObituaryCard
                data={obituary}
                index={index}
                key={index}
                mob={false}
                selectedCity={selectedCity}
                selectedRegion={selectedRegion}
                onCandleBurned={updateObituary}
              />
            ))}
          </div>
          <div className="mx-auto mobile:w-full grid grid-cols-1 tablet:hidden desktop:hidden gap-[22px] tablet:gap-6 mt-[43px] tablet:mt-[64px]">
            {obituaries.slice(0, 8).map((obituary, index) => (
              <ObituaryCard
                data={obituary}
                index={index}
                key={index}
                mob={true}
                selectedCity={selectedCity}
                selectedRegion={selectedRegion}
                onCandleBurned={updateObituary}
              />
            ))}
          </div>

          {activeTab === "latest" ? (
          <div
            className="flex w- justify-center 
        mobile:pt-[22.09px] mobile:pb-[49px]
        tablet:pt-[43px] tablet:pb-[46px]
        desktop:pt-[45px] desktop:pb-[62px]  "
          >
            <Link
              href={"/osmrtnice"}
              className="flex items-center rounded-lg justify-center shadow-custom-light-dark bg-gradient-to-br from-[#E3E8EC] to-[#FFFFFF]
          mobile:h-[43px] mobile:w-[103px]
          tablet:h-[43px] tablet:w-[97px]
          desktop:h-12 desktop:w-[125px]"
            >
              <div className="flex font-variation-customOpt16 text-[16px] text-[#1E2125] text-center">
                Naprej
              </div>
            </Link>
          </div>
          ) : (
            <div className="pb-[46px] desktop:pb-[62px]" />
          )}
            </>
          )}
        </div>

        <IpadSlider />
        <HomePageBox />
        <IphoneView />

        <div className="w-full bg-black mx-auto z-[1]">
          <div className="relative flex max-w-[1280px] mx-auto justify-center overflow-visible dekstop:h-[284px] tablet:h-[284px] mobile:h-[235px]">
            <img
              src="/viola_ozadje.avif"
              alt="Cvetličarne po občinah"
              className="h-[284px] w-[1280px] object-cover object-center mobile:h-[235px]"
            />
            {/* <div className="absolute flex flex-col items-center self-center desktop:h-[143px] desktop:w-[476px] desktop:right-[140px] tablet:h-[127px] tablet:w-[302px] tablet:left-1/2 mobile:right-[15px] mobile:h-[113px] mobile:w-[299px]"> */}
            <div className="absolute flex flex-col self-center desktop:h-[143px] desktop:w-[476px] desktop:right-[140px] tablet:h-[127px] tablet:w-[302px] tablet:left-1/2 mobile:right-[15px] mobile:h-[113px] mobile:w-[299px]">
              <div className="tablet:mb-[32px] desktop:mb-[48px] mobile:mb-[32px] mobile:text-right mobile:w-full">
                <h2
                  className="
              mobile:text-[28px]
              text-[40px]  leading-[46.88px] 
              font-normal text-[#FFFFFF]  
                mobile:leading-[32.81px] whitespace-nowrap mobile:text-right mobile:w-full"
                >
                  Lokalni partnerji
                </h2>
                <p
                  className="
              text-[20px]
              font-normal text-[#FFFFFF]  
                whitespace-nowrap mobile:text-[14px] tablet:text-[14px] mobile:text-right mobile:w-full mt-1"
                >
                  Podjetja, ki lahko pomagajo pri žalni slovesnosti
                </p>
              </div>
              <div className="relative">
                {/* <SelectDropdown
                  label={"Občina"}
                  isFromFlower={true}
                  isFromNotification={false}
                  isFrom={"mainPage"}
                  isFromFlowerGreenBgTablet={false}
                  isFromObituary={false}
                  data={cityOptions}
                  selectedValue={selectedFloristCity}
                  onSelect={handleFloristCitySelect}
                /> */}
                <SelectRegionDropdown
                  label={"Regija"}
                  isFromFlower={true}
                  isFromNotification={false}
                  isFrom={"mainPage"}
                  isFromFlowerGreenBgTablet={false}
                  isFromObituary={false}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <NotificationView /> */}
      </div>
    </Layout>
  );
}
